<template>
	<div class="contact-information variations-selection mb-5">
		<div class="contact-information-header section-title" v-if="!isMultipleVariant">
			<span :style="getStyle(node)">Pilihan Variasi</span>
		</div>

		<!-- multiple variation -->
		<div v-if="isMultipleVariant">
			<div class="ooef-variations-table-wrapper" :class="{ 'has-error': !isValid }">
				<div class="ooef-variations-table-warning text-danger">
					<span>Silahkan masukkan jumlah dari variasi yang anda inginkan</span>
					<span class="oo-variations-stock-warning hidden">
						<br />
						Dan pastikan jumlahnya tidak melebihi stok
					</span>
				</div>

				<!-- partial/ fluid -->
				<template v-if="multipleVariationShowType === 'fluid'">
					<table class="ooef-variations-table table borderless">
						<thead>
							<tr>
								<th width="70%" :style="getStyle(node)">Pilihan Variasi</th>
								<th :style="getStyle(node)">Jumlah</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in multipleVariations" :key="index">
								<td class="align-middle narrow">
									<multiselect
										:value="item.variant"
										:options="formattedPartialVarianOptions(multipleVariantAttributes)"
										:searchable="false"
										:close-on-select="true"
										:show-labels="true"
										:preselect-first="true"
										placeholder="Pilih Variasi"
										track-by="label"
										label="label"
										@select="onSelectMultipleVariant(index, ...arguments)">
										<span slot="noResult">Variasi tidak ditemukan</span>
									</multiselect>
								</td>
								<td class="narrow">
									<div class="d-flex align-items-center">
										<InputNumber
											mode="plus-minus"
											:max="item.variant.stock.quantity || 10"
											:min="0"
											:disabled="true"
											:value.sync="item.quantity"
											@change="onMultipleVariantQtyChange(index, ...arguments)"
										/>
									</div>
								</td>
								<td class="narrow va-m p-0">
									<button
										type="button"
										class="oo-variation-remove-row btn btn-light btn-circle text-danger"
										v-if="index !== 0"
										@click="removeMultipleVariant(index)">×</button>
								</td>
							</tr>
						</tbody>
					</table>
					<button type="button" class="oo-variation-add-row btn btn-light btn-block">+ {{ multipleVariationAddLabel }}</button>
				</template>

				<!-- static / all -->
				<template v-else>
					<table class="ooef-variations-table table">
						<thead>
							<tr>
								<th width="70%">
									<span :style="getStyle(node)">
										Pilihan Variasi
									</span>
								</th>
								<th>
									<span :style="getStyle(node)">Jumlah</span>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in multipleVariations" :key="index">
								<td class="align-middle">
									<div class="oo-variation-label">
										{{ item.variant.label }}
									</div>
								</td>
								<td>
									<InputNumber
										mode="plus-minus"
										:max="item.variant.stock.quantity || 10"
										:min="0"
										:disabled="true"
										:value.sync="item.quantity"
										@change="onMultipleVariantQtyChange(index, ...arguments)"
									/>
								</td>
							</tr>
						</tbody>
					</table>
				</template>
			</div>
		</div>

		<!-- not multiple variation -->
		<div class="product-variations oo-product-variations" v-else>
			<div class="product-attributes oo-product-attributes">
				<!-- loop for variation attribute -->
				<div
					class="product-attribute mb-4"
					v-for="(attr, index) in attributes"
					:key="index">
					<b :style="getStyle(node)">{{ attr.name }}</b>
					<!-- show variation attribute value -->
					<div class="row variation-container">
						<!-- variation type dropdown -->
						<template v-if="selectType === 'dropdown'">
							<multiselect
								v-model="selected[attr.name]"
								:options="attr.values"
								:searchable="false"
								:close-on-select="true"
								:show-labels="true"
								:preselect-first="true"
								:placeholder="`Pilih ${attr.name}`"
								@select="onSelectVariant">
								<span slot="noResult">{{ attr.name }} tidak ditemukan</span>
							</multiselect>
						</template>

						<!-- variation type radio -->
						<template v-else>
							<div
								class="variation-col col-md-6 p-0"
								v-for="(value, index) in attr.values"
								:key="`value-${index}`">
								<label class="variation-item m-0">
									<div class="custom-control custom-radio">
										<input
											type="radio"
											class="ooef-product-variation product-variation custom-control-input"
											:name="`variation-${attr.name}-${value}`"
											:value="value"
											v-model="selected[attr.name]"
											@change="onSelectVariant"
										/>
										<div
											:for="`variation-${attr.name}-${value}`"
											class="custom-control-label mb-0">
											<div class="variation-label">{{ value }}</div>
										</div>
									</div>
								</label>
							</div>
						</template>

					</div>
				</div>
			</div>
		</div>

		<div class="oo-variable-stock-empty alert alert-warning alert--sm hidden mt-4">
			<span>Stok dari variasi yang anda pilih sedang kosong atau kurang.</span>
		</div>
	</div>

</template>

<script>
import {
	// eslint-disable-next-line
	duplicateVar,
	displayVariation,
	getNodeStyle,
	// eslint-disable-next-line
	formattedMultipleVariantAttributeName,
} from '@/lib/helper';
import InputNumber from './InputNumber.vue';

export default {
	name: 'Variation',
	props: {
		node: {
			type: Object,
		},
		product: {
			type: Object,
			default: null,
		},
		isValid: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		InputNumber,
	},
	data() {
		return {
			isLoading: false,
			selected: {},
			quantity: {},
			selectedVarian: {},
			multipleVariations: [],
		};
	},
	computed: {
		isMultipleVariant() {
			let varian = false;
			if (this.product !== null && this.product.variations.multiple_variations) {
				varian = this.product.variations.multiple_variations.enabled;
			}
			return varian;
		},
		multipleVariationShowType() {
			let type = 'static';
			if (this.product !== null && this.product.form && this.product.form.elements && this.product.form.elements.multiple_variations && this.product.form.elements.multiple_variations.row_type) {
				type = this.product.form.elements.multiple_variations.row_type;
			}
			return type;
		},
		selectType() {
			let type = 'radio';
			if (this.product !== null && this.product.form && this.product.form.elements && this.product.form.elements.multiple_variations) {
				type = this.product.form.elements.multiple_variations.select_type;
			}
			return type;
		},
		attributes() {
			let attributes = [];
			if (this.product !== null && this.product.variations && this.product.variations.attributes) {
				attributes = this.product.variations.attributes;
			}
			return attributes;
		},
		multipleVariantAttributes() {
			let attributes = [];
			if (this.product !== null && this.product.variations && this.product.variations.prices) {
				attributes = this.product.variations.prices;
			}
			return attributes;
		},
		multipleVariationAddLabel() {
			let label = 'Add';
			if (this.product !== null && this.product.form && this.product.form.elements && this.product.form.elements.multiple_variations && this.product.form.elements.multiple_variations.add_label) {
				label = this.product.form.elements.multiple_variations.add_label;
			}
			return label;
		},
	},
	watch: {},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.setDefaultSelected();
		},
		setDefaultSelected() {
			if (!this.isMultipleVariant && this.selectType === 'radio') {
				const attributes = this.attributes;
				const selected = {};
				for (let i = 0; i < attributes.length; i++) {
					const attr = attributes[i];
					selected[attr.name] = attr.values[0];
				}
				this.selected = duplicateVar(selected);
				this.onSelectVariant();
			}

			if (this.isMultipleVariant && this.multipleVariationShowType === 'fluid') {
				const quantity = 1;
				this.addMultipleVariant(quantity);
			} else if (this.isMultipleVariant && this.multipleVariationShowType === 'static') {
				// eslint-disable-next-line
				this.multipleVariations = this.multipleVariantAttributes.map((curr) => {
					curr.label = displayVariation(curr.name);
					curr.label_with_attribute_name = formattedMultipleVariantAttributeName(this.attributes, curr.name);
					return {
						variant: curr,
						quantity: 0,
					};
				});
			}
		},
		onSelectVariant() {
			this.$emit('select-varian', 'not-multiple', this.selected);
		},
		formattedPartialVarianOptions(options) {
			const variants = options.map((curr) => {
				curr.label = displayVariation(curr.name);
				curr.label_with_attribute_name = formattedMultipleVariantAttributeName(this.attributes, curr.name);
				return curr;
			});
			return variants;
		},
		addMultipleVariant(quantity = 0) {
			const multipleVariantAttributes = this.multipleVariantAttributes;
			const variation = duplicateVar(multipleVariantAttributes[0]);
			variation.label = displayVariation(variation.name);
			variation.label_with_attribute_name = formattedMultipleVariantAttributeName(this.attributes, variation.name);
			const selected = {
				quantity,
				variant: variation,
			};
			this.multipleVariations.push(selected);
			this.updateMultipleVariants();
		},
		onSelectMultipleVariant(index, value) {
			this.multipleVariations[index].variant = value;
			this.updateMultipleVariants();
		},
		onMultipleVariantQtyChange(index, value) {
			this.multipleVariations[index].quantity = value;
			this.updateMultipleVariants();
		},
		removeMultipleVariant(index) {
			this.multipleVariations.splice(index, 1);
			this.updateMultipleVariants();
		},
		updateMultipleVariants() {
			this.$emit('select-varian', 'multiple', this.multipleVariations);
		},
		getStyle({ options }) {
			const styles = [
				'text-color',
			];
			const style = getNodeStyle(options, styles);
			return style;
		},
	},
};
</script>

<style>

</style>
